export default "__VITE_ASSET__adbfb228__"